<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <form @submit.prevent="submitLocation">
        <div class="modal-header">
          <h1>Create location</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="locationData.code" ref="codeInput" required
                   placeholder="Short location code"/>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="locationData.name" required
                   placeholder="Full location name"/>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel
          </button>
          <button type="submit" class="btn btn-primary" :disabled="isSubmitButtonDisabled">Create location</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateLocationModal',
  props: {
    siteId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      locationData: {
        code: '',
        name: '',
        site_id: this.siteId,
      },
    };
  },
  computed: {
    isSubmitButtonDisabled() {
      return this.locationData.code === '' || this.locationData.name === '';
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
  },
  methods:
      {
        submitLocation() {
          this.$emit('create-location', this.locationData);
        },
      },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>